__turbopack_context__.v({
  "breadcrumbsWrapper": "FolderHeader-module__OdWE6W__breadcrumbsWrapper",
  "folderHeader": "FolderHeader-module__OdWE6W__folderHeader",
  "folderHeaderInfo": "FolderHeader-module__OdWE6W__folderHeaderInfo",
});
